import { Box } from "@mui/material";
import React from "react";

function HighlightedName(props: { children?: React.ReactNode }) {
    return (
        <Box component="span" sx={(theme) => ({ color: theme.palette.primary.dark, fontWeight: theme.typography.fontWeightBold })}>
            {props.children}
        </Box>
    );
}

export default HighlightedName;
